
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.886.083c-.362.101-.782.32-3.844 1.984-6.91 3.76-10.615 5.8-10.906 6.009-.525.376-.897.95-1.064 1.644-.1.417-.09 1.198.015 1.528.2.61.71 1.279 1.206 1.578.482.295 14.169 6.517 14.493 6.593.472.107.882.091 1.364-.06.505-.153.772-.326 1.125-.722.434-.487.601-.877.706-1.674.052-.411 0-.807-.19-1.355-.149-.427-.592-.883-1.169-1.198-.234-.132-2.37-1.122-4.745-2.203-2.375-1.08-4.335-1.984-4.354-2.005-.024-.02.706-.451 1.621-.954 1.67-.918 5.88-3.222 7.163-3.923 1.283-.695 1.626-1.243 1.626-2.608 0-.757-.171-1.274-.615-1.838-.443-.573-1.063-.878-1.76-.873-.228 0-.534.036-.672.077z","fill":"#165A9F"}}),_c('path',{attrs:{"d":"M.711 14.638c-.391.223-.658.66-.696 1.147-.038.406.047.62.362.954.291.315.005.173 3.558 1.802.605.274 1.101.507 1.111.517.01.006-.649.376-1.455.813C.463 21.57.358 21.64.124 22.139c-.219.467-.143.827.282 1.345.377.457.834.594 1.311.39.353-.151 6.443-3.516 6.715-3.714.29-.203.544-.513.653-.787.086-.218.09-.716.01-.903-.162-.376-.568-.7-1.326-1.066a444.085 444.085 0 00-5.742-2.65c-.62-.263-.997-.299-1.316-.116z","fill":"#FE6600"}})])
          )
        }
      }
    